import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/dm-sans';
import { ChakraProvider } from '@chakra-ui/react';
import { system } from './theme';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider value={system}>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
